// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__y8Alm","errors":"Errors_errors__3jXZL"};